<template>
  <div class="tree-item">
    <p
      @click="isExpanded = !isExpanded"
      :style="{ marginLeft: `${level * 1}rem` }"
      :class="classMethod(data)"
    >
      <template v-if="data.children && data.children.length > 0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          v-if="!isExpanded"
          class="w-6 h-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M9 5l7 7-7 7"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6"
          v-if="isExpanded"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </template>
      <slot :group="data"></slot>
    </p>
    <div
      class="children"
      v-if="data.children"
      v-show="isExpanded"
      :key="level + 1 + `child-container`"
    >
      <tree-item
        v-for="(d, index) in data.children"
        :level="level + 1"
        :key="level + 1 + `tree-item` + index"
        :data="d"
        :classMethod="classMethod"
        v-slot:default="slotProps"
        ><slot :group="slotProps.group"></slot
      ></tree-item>
    </div>
  </div>
</template>

<script>
export default {
  name: "tree-item",
  data() {
    return {
      isExpanded: false
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    level: {
      type: Number,
      default: 0
    },
    classMethod: {
      type: Function,
      default: () => {}
    }
  }
};
</script>

<style lang="postcss">
.tree-item {
  background: none;
}

.tree-item p {
  @apply bg-primary-light m-1 p-4 rounded;
}

.tree-item p.disabled {
  @apply opacity-50;
}

.tree-item p.primary {
  @apply bg-primary;
}

.children {
  background: none;
}

.children p {
  @apply mt-2;
}
</style>
